export default __webpack_public_path__ + "bc4277e1f16239cff16d344b110712ef.png";